<div class="prod-service-loading">
  <div class="spen-mod-flex-loading">
    <div class="loading-icon"></div>
  </div>
</div>
